<template>
	<section class="brand-add">
		<article class="brand-add--page">
			<ManagingSection>
				<ManagingBox title="상태" v-if="pageType === 'edit'">
					<RadioList
						:radioList="statusList"
						:value="brandStatus"
						@input="brandStatusChange"
					/>
				</ManagingBox>
				<ManagingBox title="브랜드 번호" v-if="pageType === 'edit'">
					<p>{{ $route.params.idBrand }}</p>
				</ManagingBox>
				<ManagingBox title="브랜드명">
					<input
						type="text"
						placeholder="브랜드명을 입력하세요"
						v-model="newBrand.name"
					/>
				</ManagingBox>
				<ManagingBox title="브랜드명(보조)">
					<input
						type="text"
						placeholder="영문등 보조 브랜드명을 입력하세요"
						v-model="newBrand.subName"
					/>
				</ManagingBox>
				<ManagingBox title="국가">
					<SearchBrandCountry
						@change="getBrandCountry"
						ref="brandCountry"
					/>
				</ManagingBox>
				<ManagingBox title="등록일" v-if="pageType === 'edit'">
					<p>
						{{ createDate || '-' }} ( {{ insertAdminName || '-' }} )
					</p>
				</ManagingBox>
				<ManagingBox title="수정일" v-if="pageType === 'edit'">
					<p>
						{{ modifiedDate || '-' }} (
						{{ updateAdminName || '-' }} )
					</p>
				</ManagingBox>
				<ManagingBox title="로고">
					<ImageUploader
						group="brand-logo"
						:image-size-limit="{
							previewWidth: 100,
							width: 100,
							height: 100,
							type: 'fit',
						}"
						:limit="false"
						@upload="onImageUpload"
						ref="imageUploader"
					/>
				</ManagingBox>
				<ManagingBox title="홈페이지">
					<input
						type="text"
						placeholder="홈페이지 주소를 입력하세요"
						v-model="newBrand.brandUrl"
					/>
				</ManagingBox>
				<ManagingBox title="페이스북">
					<input
						type="text"
						placeholder="페이스북 주소를 입력하세요"
						v-model="newBrand.brandFacebook"
					/>
				</ManagingBox>
				<ManagingBox title="엑스">
					<input
						type="text"
						placeholder="엑스 주소를 입력하세요"
						v-model="newBrand.twitter"
					/>
				</ManagingBox>
				<ManagingBox title="인스타그램">
					<input
						type="text"
						placeholder="인스타그램 주소를 입력하세요"
						v-model="newBrand.instagram"
					/>
				</ManagingBox>
				<ManagingBox title="카카오톡">
					<input
						type="text"
						placeholder="카카오톡 주소를 입력하세요"
						v-model="newBrand.kakaotalk"
					/>
				</ManagingBox>
				<ManagingBox title="유튜브">
					<input
						type="text"
						placeholder="유튜브 주소를 입력하세요"
						v-model="newBrand.youTube"
					/>
				</ManagingBox>
				<ManagingBox title="연락처">
					<div class="brand-add__tel">
						<input
							type="text"
							v-model="newBrand.startTel"
							placeholder="0000"
						/>
						-
						<input
							type="text"
							v-model="newBrand.midTel"
							placeholder="0000"
						/>
						-
						<input
							type="text"
							v-model="newBrand.endTel"
							placeholder="0000"
						/>
					</div>
				</ManagingBox>
				<ManagingBox title="브랜드 카테고리">
					<CheckboxList
						:checkboxList="brandCategoryList"
						:value="selectedBrandCategories"
						@input="changeBrandCategory"
					/>
				</ManagingBox>
				<ManagingBox title="기본 스토어">
					<CheckboxList
						:checkboxList="brandTypeList"
						@input="changeBrandType"
						:value="selectedStoreCategories"
					/>
				</ManagingBox>
				<ManagingBox title="제품수" v-if="pageType === 'edit'">
					<a
						:href="`/product/product-list?idBrand=${$route.params.idBrand}`"
						class="brand-add__product-count"
						target="_blank"
						>{{ Number(productCount).toLocaleString() }}</a
					>
				</ManagingBox>
				<ManagingBox title="제품 통계" v-if="pageType === 'edit'">
					<table class="table-main">
						<thead>
							<tr>
								<th>조회수 총합</th>
								<th>리뷰수 총합</th>
								<th>위시수 총합</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									{{ Number(readCount).toLocaleString() }}
								</td>
								<td>
									{{ Number(reviewCount).toLocaleString() }}
								</td>
								<td>
									{{ Number(wishCount).toLocaleString() }}
								</td>
							</tr>
						</tbody>
					</table>
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button class="btn-main blue" type="button" @click="saveBrand">
					{{ pageType === 'edit' ? '수정하기' : '저장하기' }}
				</button>
				<button
					class="btn-main bordered blue"
					type="button"
					@click="init"
				>
					다시작성
				</button>
			</div>
		</article>
		<BrandComment
			v-if="pageType === 'edit'"
			:brandId="$route.params.idBrand"
		/>
	</section>
</template>

<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import ImageUploader from '@/components/ImageUploader.vue';
	import CheckboxList from '@/components/CheckboxList';
	import SearchBrandCountry from '@/components/SearchBrandCountry.vue';
	import { mapState } from 'vuex';
	import { getImagePath } from '@/util';
	import RadioList from '@/components/RadioList.vue';
	import { formattedDate } from '../../util';
	import BrandComment from './BrandComment.vue';
	import RightMemoBox from '../../components/RightMemoBox.vue';

	export default {
		name: 'BrandAdd',
		components: {
			ManagingSection,
			ManagingBox,
			ImageUploader,
			CheckboxList,
			SearchBrandCountry,
			RadioList,
			BrandComment,
			RightMemoBox,
		},
		props: {
			pageType: {
				type: String,
				default: 'add',
			},
		},
		data() {
			return {
				brandCategoryList: [],
				brandTypeList: [],
				countryList: [],
				logoImage: {},
				newBrand: this.getInitialNewBrand(),
				selectedBrandCategories: [],
				selectedStoreCategories: [],
				imageSrc: '',
				wishCount: '',
				reviewCount: '',
				readCount: '',
				productCount: '',
				statusList: [
					{ id: 'Y', value: '노출' },
					{ id: 'N', value: '미노출' },
				],
				brandStatus: 'Y',
				updateAdminName: '',
				insertAdminName: '',
				createDate: '',
				modifiedDate: '',
			};
		},
		computed: {
			getTel() {
				return `${this.newBrand.startTel}${this.newBrand.midTel ? `-${this.newBrand.midTel}` : ''}${this.newBrand.endTel ? `-${this.newBrand.endTel}` : ''}`;
			},
			...mapState({
				adminDomain: state => state.env.adminDomain,
			}),
		},
		methods: {
			getInitialNewBrand() {
				return {
					brandTitle: '',
					name: '',
					subName: '',
					brandTitleInitial: '',
					brandUrl: '',
					brandFacebook: '',
					twitter: '',
					kakaotalk: '',
					youTube: '',
					instagram: '',
					startTel: '',
					midTel: '',
					endTel: '',
					fileOrgName: '',
					fileSaveName: '',
					fileDir: '',
					fileSize: '',
					fileType: '',
					country: '',
				};
			},
			async setData() {
				try {
					const [brandTypeResponse, categoryResponse] =
						await Promise.all([
							this.$axiosAdmin2.get('/api/brands/brandTypeList'),
							this.$axiosAdmin2.get('/api/brands/category'),
						]);

					const brandTypeListData = brandTypeResponse.data;
					const categoryListData = categoryResponse.data;

					this.brandTypeList = brandTypeListData.data
						.filter(item => item.isDisplay === 'Y')
						.map(item => ({
							id: item.idBrandType,
							value: item.brandTypeName,
						}));

					this.brandCategoryList = categoryListData.map(item => ({
						id: item.idBrandCategory,
						value: item.brandCategoryText,
					}));
				} catch (err) {
					console.error(err);
					alert(
						'데이터를 불러오는데 실패했습니다. 개발팀에 문의하세요'
					);
				}
			},
			async getBrandData() {
				try {
					const {
						data: { brand },
					} = await this.$axiosAdmin2.get(
						`/api/brands/${this.$route.params.idBrand}`
					);
					const {
						name,
						subName,
						country,
						brandUrl,
						brandFacebook,
						twitter,
						kakaotalk,
						youTube,
						instagram,
						tel,
						brandCategories,
						brandTypes,
						fileOrgName,
						fileSaveName,
						fileDir,
						fileSize,
						fileType,
						wishCount,
						readCount,
						reviewCount,
						productCount,
						insertAdminName,
						updateAdminName,
						modifiedDate,
						createDate,
					} = brand;
					const [startTel, midTel, endTel] = tel.split('-');

					this.newBrand = {
						...this.getInitialNewBrand(),
						name,
						subName,
						country,
						brandUrl,
						brandFacebook,
						twitter,
						kakaotalk,
						youTube,
						instagram,
						startTel,
						midTel,
						endTel,
						fileOrgName,
						fileSaveName,
						fileDir,
						fileSize,
						fileType,
					};

					this.selectedBrandCategories = brandCategories;
					this.selectedStoreCategories = brandTypes;
					this.wishCount = wishCount;
					this.readCount = readCount;
					this.reviewCount = reviewCount;
					this.productCount = productCount;
					this.insertAdminName = insertAdminName;
					this.updateAdminName = updateAdminName;
					this.createDate = createDate && formattedDate(createDate);
					this.modifiedDate =
						modifiedDate && formattedDate(modifiedDate);
					this.brandStatus = brand.isDisplay ? 'Y' : 'N';

					this.$refs.brandCountry.$refs.input.value = country;
					this.$refs.imageUploader.setImageByUrl(
						getImagePath(fileDir, fileSaveName)
					);
				} catch (err) {
					console.error(err);
				}
			},
			saveBrand() {
				if (!this.validation()) {
					return false;
				}

				const params = {
					name: this.newBrand.name,
					subName: this.newBrand.subName,
					brandUrl: this.newBrand.brandUrl,
					brandFacebook: this.newBrand.brandFacebook,
					twitter: this.newBrand.twitter,
					kakaotalk: this.newBrand.kakaotalk,
					youTube: this.newBrand.youTube,
					instagram: this.newBrand.instagram,
					tel: this.getTel,
					fileOrgName: this.newBrand.fileOrgName,
					fileSaveName: this.newBrand.fileSaveName,
					fileDir: this.newBrand.fileDir,
					fileSize: this.newBrand.fileSize,
					fileType: this.newBrand.fileType,
					country: this.newBrand.country,
					brandCategories: this.selectedBrandCategories,
					brandTypes: this.selectedStoreCategories,
				};

				if (this.pageType === 'edit') {
					params.isDisplay = this.brandStatus === 'Y' ? true : false;
					this.updateBrand(params);
				} else {
					this.saveNewBrand(params);
				}
			},
			async saveNewBrand(params) {
				try {
					await this.$axiosAdmin2.post('/api/brands', params);
					alert('등록하였습니다.');
					this.init();
					this.$router.push('/brand/list');
				} catch (error) {
					console.error(error);
					alert(
						'브랜드를 등록에 실패했습니다. 지속적인 발생시 개발팀에 문의하세요'
					);
				}
			},
			async updateBrand(params) {
				try {
					await this.$axiosAdmin2.put(
						`/api/brands/${this.$route.params.idBrand}`,
						params
					);
					alert('수정하였습니다.');
					this.init();
					this.$router.go(-1);
				} catch (error) {
					console.error(error);
					alert(
						'브랜드 수정에 실패하였습니다. 지속적인 발생시 개발팀에 문의하세요'
					);
				}
			},
			onImageUpload(image) {
				this.logoImage = image;
				this.newBrand = {
					...this.newBrand,
					fileOrgName: image.fileOrgName,
					fileSaveName: image.fileSaveName,
					fileDir: image.fileDir,
					fileSize: image.fileSize,
					fileType: image.fileType,
				};
			},
			getBrandCountry($event) {
				this.newBrand.country = $event;
			},
			changeBrandCategory($event) {
				this.selectedBrandCategories = $event;
			},
			changeBrandType($event) {
				this.selectedStoreCategories = $event;
			},
			init() {
				this.newBrand = {
					brandTitle: '',
					name: '',
					subName: '',
					brandTitleInitial: '',
					brandUrl: '',
					brandFacebook: '',
					twitter: '',
					kakaotalk: '',
					youTube: '',
					instagram: '',
					startTel: '',
					midTel: '',
					endTel: '',
					fileOrgName: '',
					fileSaveName: '',
					fileDir: '',
					fileSize: '',
					fileType: '',
					country: '',
				};
				this.logoImage = {};
				this.$refs.imageUploader.cancelImage();
				this.$refs.brandCountry.init();
				this.selectedBrandCategories = [];
				this.selectedStoreCategories = [];
				this.brandStatus = 'Y';
			},
			validation() {
				if (!this.newBrand.name) {
					alert('브랜드명을 입력해주세요');
					return false;
				}
				if (!this.newBrand.country) {
					alert('국가를 선택해주세요');
					return false;
				}
				if (!this.newBrand.fileOrgName) {
					alert('로고를 업로드해주세요');
					return false;
				}
				return true;
			},
			brandStatusChange(status) {
				this.brandStatus = status;
			},
		},

		mounted() {
			this.setData();
			if (this.pageType === 'edit') {
				this.getBrandData();
			}
		},
	};
</script>

<style lang="scss">
	.brand-add {
		position: relative;
		&__tel {
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 10px;
			input {
				width: 30%;
			}
		}

		&__product-count {
			color: #007bff;
			cursor: pointer;
			font-size: 17px;
		}
	}
</style>
